import React, { FunctionComponent, useEffect } from 'react'
import { injectIntl, InjectedIntlProps } from 'react-intl'
import camelCase from 'lodash/camelCase' // this will be used for camelCasing ticketButtonText
import { shouldUseBetaCheckout } from 'src/components/calendar/calendarUtils'

const style = require('./TicketButton.css')
import locale from '../locale'
import { trackGetTickets } from 'src/lib/analytics'

interface Props {
  eventId: string,
  hostId: string,
  baseUrl: string,
  listingStatus: string,
  ticketButtonText: string,
  isTimedEntry: boolean,
  viewer: any,
}

declare var $u

const TicketButtonComponent: FunctionComponent<Props & InjectedIntlProps> = ({
  eventId,
  hostId,
  baseUrl,
  listingStatus,
  ticketButtonText,
  isTimedEntry,
  viewer,
  intl
}) => {
  useEffect(() => loadTicketWidget(), [])

  // BETA FEATURE: New Checkout. TODO: Pass real data, rather than URL param.
  const searchString = window.location.search
  const useBetaCheckout = shouldUseBetaCheckout(searchString)

  const getJunoUrl = () => {
    $u.open(eventId, { betaCheckoutEnabled: useBetaCheckout })
    const trackingParams = { isTimedEntry, eventId, hostId, widget: 'button', viewer }
    trackGetTickets(trackingParams);
  };

  const loadTicketWidget = () => {
    const loadScript = document.createElement('script')
    loadScript.src = `${baseUrl}/embed2.js`
    loadScript.id = 'juno-script'
    window.document.querySelector(`.${style.container}`).appendChild(loadScript)
  }

  const assignButtonText = (locale: ReactIntl.FormattedMessage.MessageDescriptor) => {
    return intl.formatMessage(locale).toLocaleUpperCase();
  }

  const determineButtonText = () => {
    if (ticketButtonText !== "get_tickets") return camelCase(ticketButtonText);
    return camelCase(ticketButtonText);
  }

  const clickable = () => {
    switch (listingStatus) {
      case "soldoutWaitlistEnabled":
      case "salesEnded":
      case "salesEndedEventOver":
      case "unavailableAllHidden":
      case "unavailableOnlyAtDoor":
      case "unavailableGeofenced":
      case "semiAvailableNotStarted":
      case "availableStandard":
      case "semiAvailableAllLocked":
        return true;
      case "soldoutWaitlistNotEnabled":
      case "noData":
        return false;
    }
  }

  const buttonClass = () => {
    switch (listingStatus) {
      case "semiAvailableNotStarted":
      case "semiAvailableAllLocked":
      case "availableStandard":
        return style.primary;
      case "soldoutWaitlistEnabled":
        return style.secondary;
      case "salesEnded":
      case "salesEndedEventOver":
      case "unavailableAllHidden":
      case "unavailableOnlyAtDoor":
      case "unavailableGeofenced":
        return style.tertiary;
      case "soldoutWaitlistNotEnabled":
      case "noData":
        return style.disabled;
    }
  }

  const buttonTextLocaleKey = () => {
    switch (listingStatus) {
      case "soldoutWaitlistEnabled":
        return "joinWaitlist";
      case "soldoutWaitlistNotEnabled":
      case "salesEnded":
      case "salesEndedEventOver":
      case "unavailableAllHidden":
      case "unavailableOnlyAtDoor":
      case "unavailableGeofenced":
      case "noData":
        return "details";
      case "availableStandard":
      case "semiAvailableNotStarted":
      case "semiAvailableAllLocked":
        return determineButtonText();
    }
  }

  return (
    <button className={`${style.container} ${buttonClass()}`} onClick={getJunoUrl} disabled={!clickable()}>
      {assignButtonText(locale[buttonTextLocaleKey()])}
    </button>
  )
}

export const TicketButton = injectIntl(TicketButtonComponent)
